/**
 * Read-only React Query hook for a workflow's currently published
 * definition (Tier-1 Understand view, P1.T7).
 *
 * Fetches GET /api/workflows/:id/definition (backend Task 6, gated by
 * the workflow_transparency feature) and caches the result for 60s.
 */
import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { apiClient } from '@/services/apiClient'
import type { WorkflowDefinitionRead } from '@/types/workflowDefinition'

export function workflowDefinitionQueryKey(workflowId: string) {
  return ['workflows', 'definition', workflowId] as const
}

export function useWorkflowDefinition(
  workflowId: string | undefined,
): UseQueryResult<WorkflowDefinitionRead, Error> {
  return useQuery<WorkflowDefinitionRead, Error>({
    queryKey: workflowDefinitionQueryKey(workflowId ?? ''),
    queryFn: () =>
      apiClient.get<WorkflowDefinitionRead>(`/api/workflows/${workflowId}/definition`),
    enabled: !!workflowId,
    staleTime: 60_000,
  })
}
